module.exports = __webpack_public_path__ + "media/exports/required/assets/img/newicons/exam_status_success-e660f28d45185473fbbfc333cab17268.svg";